import { useState, useRef } from 'react';
import { createPortal } from 'react-dom';

const ToolTipWithTrigger = ({ body, children, tooltipPosition = 'top' }) => {
  const [visible, setVisible] = useState(false);
  const targetRef = useRef(null);
  const tooltipRef = useRef(null);
  const timeoutId = useRef(null);

  const showTooltip = () => {
    clearTimeout(timeoutId.current);
    setVisible(true);
  };

  const hideTooltip = () => {
    timeoutId.current = setTimeout(() => setVisible(false), 300);
  };

  const getPositionStyle = () => {
    const target = targetRef.current;
    if (!target) return {};
    const rect = target.getBoundingClientRect();
    const spacing = 8;

    const top = rect.top - spacing;
    const left = rect.left + rect.width / 2;

    return {
      top: `${top + window.scrollY}px`,
      left: `${left + window.scrollX}px`,
      transform: 'translate(-50%, -100%)'
    };
  };

  return (
    <>
      <span
        ref={targetRef}
        onMouseEnter={showTooltip}
        onMouseLeave={hideTooltip}
        style={{ cursor: 'pointer', display: 'inline-block' }}
      >
        {children}
      </span>

      {visible &&
        createPortal(
          <div
            ref={tooltipRef}
            onMouseEnter={showTooltip}
            onMouseLeave={hideTooltip}
            className="tooltip bs-tooltip-top show"
            role="tooltip"
            style={{
              position: 'absolute',
              zIndex: 110,
              ...getPositionStyle()
            }}
          >
            <div className="tooltip-arrow" />
            <div className="tooltip-inner">{body}</div>
          </div>,
          document.body
        )}
    </>
  );
};

export default ToolTipWithTrigger;
